export default __webpack_public_path__ + "static/media/face2.b503111d.png";